export const InfoMenuDot = {
	create (container) {
		container.parent().parent().find('.button-dot-menu').on('click', function(e) {
			e.preventDefault();

			const open = container.parent().parent().find('.button-dot-actions-container').data('open');

			container.parent().parent().parent().find('.button-dot-actions-container').css('display', 'none');
			container.parent().parent().parent().find('.button-dot-actions-container').data('open', false);
			container.parent().parent().parent().find('.button-dot-menu').removeClass('button-dot-menu-hover');

			if (!open) {
				container.parent().parent().find('.button-dot-actions-container').data('open', true);
				container.parent().parent().find('.button-dot-actions-container').css('display', 'block');

				const c = container.parent().parent().find('.button-dot-actions-container');
				const items = c.find('li');

				if (($('#right-pane').height() - c.position().top) < 70*items.length) {
					c.css('margin-top', `-${((items.length - 1) * 40)+30}px`);
				} else {
					c.css('margin-top', '10px');
				}

				$(this).addClass('button-dot-menu-hover');
			} else {
				container.parent().parent().find('.button-dot-actions-container').css('display', 'none');
				container.parent().parent().find('.button-dot-actions-container').data('open', false);
				$(this).removeClass('button-dot-menu-hover');
			}

			container.parent().parent().find('.button-dot-actions-container > ul > li').on('mouseover', function() {
				container.addClass('panel-title-hover');
				container.trigger('mouseover');
			});

			container.parent().parent().find('.button-dot-actions-container > ul > li').on('mouseout', function() {
				container.removeClass('panel-title-hover');
				container.trigger('mouseout');
			});

			container.parent().parent().find('.button-dot-actions-container > ul > li').on('click', function() {
				container.parent().parent().find('.button-dot-actions-container').css('display', 'none');
				container.parent().parent().find('.button-dot-actions-container').data('open', false);
				container.parent().parent().find('.button-dot-menu').removeClass('button-dot-menu-hover');
			});
		});

		container.on('mouseover', () => {
			container.parent().parent().find('.button-dots').css('display', 'block');
		});

		container.on('mouseout', () => {
			container.removeClass('panel-title-hover');
			container.parent().parent().find('.button-dots').css('display', 'none');

			container.parent().parent().parent().find('.button-dot-actions-container').each((idx, el) => {
				if (el !== container.parent().parent().find('.button-dot-actions-container')[0]) {
					$(el).css('display', 'none');
					$(el).data('open', false);
				}
			});
		});

		container.parent().parent().find('.button-dot-menu').on('mouseover', function() {
			container.addClass('panel-title-hover');
			container.trigger('mouseover');
		});

		container.parent().parent().find('.button-dot-menu').on('mouseout', function() {
			container.removeClass('panel-title-hover');
			container.trigger('mouseout');
		});

	},
	closeAll () {
		setTimeout(() => {
			$('.button-dot-actions-container').css('display', 'none');
			$('.button-dot-actions-container').data('open', false);
			$('.button-dot-menu').removeClass('button-dot-menu-hover');
		}, 100);
	}
};



// WEBPACK FOOTER //
// ./src/scripts/shared/InfoMenuDot.js